export default "__VITE_ASSET___6wBHf2L__"